import React, { useState } from 'react';


const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const MAILCHIMP_FORM_ACTION_URL = 'https://unieros.us1.list-manage.com/subscribe/post?u=63f8f6808983a67e8a71f3ae0&amp;id=339224ebb6&amp;f_id=004270e2f0';

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      setSubmitted(true);
    }
  };

  if (submitted) {
    return <p>Thank you for subscribing to our newsletter!</p>;
  }

  return (
    <div className="newsletter-signup container">
      <h2>Get upcoming events</h2>
      <p>Our newsletter offers exclusive content with latest in multicultural events delivered to your inbox.</p>
      <form action={MAILCHIMP_FORM_ACTION_URL} method="post" onSubmit={handleSubmit} target="_blank" noValidate>
        <div>
          <label htmlFor="email">Email Address</label>
          <input
            className="form-control"
            type="email"
            name="EMAIL"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
          <input type="text" name="b_XXXXXXXXXXXXXXXXXXXXXXXXXX" tabIndex="-1" value="" readOnly />
        </div>
        <div className="col-lg-6 col-xxl-4 my-3 mx-auto">
        <button className="btn btn-unieros mb-3" type="submit">Subscribe</button>
        </div>
      
      </form>
    </div>
  );
};

export default NewsletterSignup;
